import $ from "jquery";

// spacer size
var navHeight = $('.nav_desktop_b4ba').height();
$('.nav_desktop_b4ba__spacer').css({'height': navHeight + 'px'})

// dropdown-mega
$('.nav_desktop_b4ba__menu > ul > li').on('mouseenter', function(){
  var $li = $(this);
  
  if($li.hasClass('dropdown_mega')) {
    var data_dropdown_mega = $li.attr('data-dropdown-mega');

    $('.nav_desktop_b4ba__dropdown_mega').removeClass('show_dropdown_mega');
    $('.nav_desktop_b4ba__dropdown_megas [data-dropdown-mega="' + data_dropdown_mega + '"]').addClass('show_dropdown_mega');
  } else {
    $('.nav_desktop_b4ba__dropdown_mega').removeClass('show_dropdown_mega');
  }
});

// dropdown
$('.nav_desktop_b4ba__menu > ul > li').on('mouseenter', function(){
  var $li = $(this);
  
  if($li.hasClass('dropdown')) {
    $('.nav_desktop_b4ba__menu li').removeClass('show_dropdown');
    $li.addClass('show_dropdown');
  } else {
    $('.nav_desktop_b4ba__menu li').removeClass('show_dropdown');
  }
});

// leave nav
$('.nav_desktop_b4ba').on('mouseleave', function(){
  $('.nav_desktop_b4ba__dropdown_mega').removeClass('show_dropdown_mega');
  $('.nav_desktop_b4ba__menu li').removeClass('show_dropdown');
});


var prevScrollpos = window.pageYOffset;
window.onscroll = function() {
  var currentScrollPos = window.pageYOffset;
  if (prevScrollpos > currentScrollPos) {
    document.getElementById("nav_desktop_b4ba").style.opacity = "1";
  } else {
    document.getElementById("nav_desktop_b4ba").style.opacity = "0";
  }
  prevScrollpos = currentScrollPos;
}

// scroll
var scrollPos = 0;
var navactive = false; 

$(window).scroll(function(){
    scrollPos = $(document).scrollTop();

        if(scrollPos > 5){
            $('.nav_desktop_b4ba').addClass('scrolled');
        }else{

            $('.nav_desktop_b4ba').removeClass('scrolled');
        }
});

// transitions

// require("waypoints/lib/noframework.waypoints.min");
// var $transitions = $(".text-animation");
// $transitions.addClass("not-animated");
// $transitions.each(function () {
//   var $transition = $(this);
//   new Waypoint({
//     element: $transition[0],
//     handler: (direction) => {
//       if (direction == "down") {
//         // console.log("down");
//         $transition.removeClass("not-animated");
//         $transition.addClass("animated");
//       }
//       if (direction == "up") {
//         // console.log("up");
//       }
//     },
//     offset: "95%",
//   });
// });